import styled from 'styled-components';
import { motion } from 'framer-motion';

import colours from 'theme/atoms/colours';
import typography from 'theme/atoms/typography';
import { GhostIcon } from 'theme/components/Buttons.style';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
`;

export const ArrowButton = styled(GhostIcon).attrs({ $size: 'medium' })`
  display: none;
  flex-shrink: 0;

  @media (min-width: 500px) {
    display: flex;
  }
`;

export const Container = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  touch-action: pan-y;
  user-select: none;
`;

export const Track = styled(motion.div)`
  display: flex;
  width: 100%;
  will-change: transform;
`;

export const Week = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex: 0 0 100%;
  min-width: 0;
`;

export const DayCell = styled.button<{
  $selected?: boolean;
  $faded?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  width: 50px;
  padding: 10px 4px;
  border: none;
  border-radius: 15px;
  background-color: ${({ $selected }) =>
    $selected ? colours.neutral[900] : 'transparent'};
  color: ${({ $selected, $faded }) => {
    if ($selected) return colours.shade[0];
    if ($faded) return colours.neutral[500];
    return colours.neutral[900];
  }};
  cursor: ${({ $faded }) => ($faded ? 'default' : 'pointer')};
  transition: background-color 0.15s ease, color 0.15s ease;

  &:focus-visible {
    outline: 2px solid ${colours.neutral[700]};
    outline-offset: 2px;
  }
`;

export const DayLabel = styled.span<{
  $selected?: boolean;
  $faded?: boolean;
  $isMonth?: boolean;
}>`
  ${typography.label}
  color: ${({ $selected, $faded, $isMonth }) => {
    if ($selected) return 'inherit';
    if ($isMonth) return colours.neutral[900];
    if ($faded) return 'inherit';
    return colours.neutral[600];
  }};
`;

export const DayNumber = styled.span`
  ${typography.p2}
  color: inherit;
`;
